import React, { useEffect } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils';
import { UIStateContainer } from '@atlassian/jira-servicedesk-reports-common/src/controllers/ui-state-store';
import type { ReportAppProps } from '@atlassian/jira-servicedesk-reports-common/src/ui/date-filter/types';
import type { ProjectId } from '@atlassian/jira-shared-types/src/general.tsx';
import { GlobalPageLoadExperience } from '@atlassian/ufo';
import { KbRequestsReportsMain } from './main';

type Props = ReportAppProps & {
	projectId: ProjectId;
};

const KbRequestsReports = ({ routerProps, baseUrl, projectId, projectKey, projectName }: Props) => {
	const route = useCurrentRoute();

	useEffect(() => {
		if (route.perfMetricKey) {
			GlobalPageLoadExperience.setPageLoadId(route.perfMetricKey);
		}
	}, [routerProps.reportId, route.perfMetricKey]);

	return (
		<JSErrorBoundary
			id="reportsKBRequests"
			packageName="jiraServicedeskKbRequestsReports"
			fallback="flag"
		>
			<UIStateContainer
				scope="kb-requests"
				baseUrl={baseUrl}
				projectKey={projectKey}
				projectId={projectId}
				routerProps={routerProps}
				projectName={projectName}
			>
				<KbRequestsReportsMain
					routerProps={routerProps}
					baseUrl={baseUrl}
					projectKey={projectKey}
					projectName={projectName}
				/>
			</UIStateContainer>
		</JSErrorBoundary>
	);
};

export default KbRequestsReports;
